export enum DateCriteria {
    week = 0,
    timeInterval = 1,
    prerequisiteActivity = 2
}